export function bankersRounding(value: number, decimals = 2) {
  let factor = Math.pow(10, decimals);
  let scaledValue = value * factor;
  let rounded = Math.round(scaledValue);

  if (Math.abs(scaledValue % 1) === 0.5) {
    rounded = rounded % 2 === 0 ? rounded : rounded - 1;
  }

  return rounded / factor;
}
